import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => (
  <Reveal>
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      {eyebrow && <p className="wp-label text-xs text-wp-rose-strong">{eyebrow}</p>}
      <h2 className="mt-2 text-2xl sm:text-3xl lg:text-4xl tracking-[-0.01em]">{title}</h2>
      {subtitle && <p className="mt-3 text-sm sm:text-base leading-relaxed text-wp-ink-muted">{subtitle}</p>}
    </div>
  </Reveal>
);
